export default {
    'diagram3b3-5': {
        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
        'element_1_1': 'American economy retreated between 1973 and 1993',
        'element_1_2': 'Lost advantages of conventional mass production and distribution',
        'element_1_3': 'Lost high rates of capital investment',
        'element_1_4': 'Lost sole access to vast efficient marketplace and cheap natural resources',
        'hint-title': 'Hint',
        'resubmit-title': 'Resubmit'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b3/diagram5/i18n/en.js